import { useAccount, useChainId } from 'wagmi'
import { useQuery } from '@tanstack/react-query'
import { ZERO_ADDRESS } from '@/web3/constants'
import { ContractName, getContractAddress } from '@/constants/contract-addresses'
import useBlockPotTokenRead from '../read/useBlockPotTokenRead'

export type BlockPotTokenState = {
    balance: bigint,
    rewardTrackerAllowance: bigint
}

export default function useBlockPotTokenData() {
    const chainId = useChainId()
    const { address } = useAccount()
    const blockPotToken = useBlockPotTokenRead()

    const { data } = useQuery<BlockPotTokenState>({
        queryKey: ['blockPotToken', chainId, address ?? ZERO_ADDRESS],
        queryFn: async () => {
            const balance = await blockPotToken.balanceOf([address ?? ZERO_ADDRESS])
            const rewardTrackerAllowance = await blockPotToken.allowance([address ?? ZERO_ADDRESS, getContractAddress(chainId, ContractName.BLOCK_POT_REWARD_TRACKER)])
            return {
                balance,
                rewardTrackerAllowance
            }
        }
    })

    return data ?? {
        balance: 0n,
        rewardTrackerAllowance: 0n,
    }
}